import ThailandAutoComplete from "vue-thailand-address-autocomplete";
// import apiCus from '../../services/service_customer'
import apiMain from "../../services/service";
import Swal from "sweetalert2";
import moment from "moment";
import _ from "lodash";
import * as XLSX from "xlsx";

export default {
  components: {
    ThailandAutoComplete
  },
  data () {
    return {
      cus_age: 0,
      last_date: new Date(),
      title: "จัดการข้อมูลลูกหนี้",
      search: "",
      startDate: moment(new Date()),
      endDate:  moment(new Date()),
      currentPage: 1,
      items_perpage: 10,
      modal_data: {
        id: 0,
        code: "",
        tax_id: "",
        name: "",
        credit_day: 0,
        debt_limit: 0,
        debt_balance: 0,
        telephone: "",
        address: "",
        sub_district: "",
        district: "",
        province: "",
        post_code: "",
        gender_id: null,
        birth_date: "",
        facebook: "",
        line_id: "",
        active_status: 1
      },
      modal_title: "",
      data_list: [],
      header: {
        "Access-Token": this.$store.state.token
      },
      branch: 0,
      dyn_address: "0",
      form_data: ""
    };
  },
  computed: {
    filterData: function () {
      let text = this.search.trim();
      return this.data_list.filter(customer => {
        return (
          customer.name.indexOf(text) > -1 || customer.code.indexOf(text) > -1
        );
      });
    },
    paginate: function () {
      this.totalItem = this.filterData.length;
      if (this.currentPage >= this.totalPages) {
        this.currentPage = Math.max(0, this.totalPages - 1);
      }
      var index = (this.currentPage - 1) * this.items_perpage;
      return this.filterData.slice(index, index + this.items_perpage);
    }
  },
  methods: {
    async saveExcel () {
      const exportData = _.chain(this.filterData)
        .groupBy(e => e.branch_name)
        .map((value, key) => {
          return {
            key,
            value: value.map(e => ({
              รหัส: e.code,
              นามลูกค้า: e.name,
              รายการ: "รายการ",
              หมายเหตุ: "หมายเหตุ",
              ของขวัญ: "ของขวัญ",
              ซื้อล่าสุด: "ซื้อล่าสุด"
            }))
          };
        })
        .value();
      const wb = XLSX.utils.book_new();
      for (const b of exportData) {
        var ws = XLSX.utils.json_to_sheet(b.value, {
          header: ["รหัส", "นามลูกค้า", "รายการ", "หมายเหตุ", "ของขวัญ"]
        });
        XLSX.utils.book_append_sheet(wb, ws, b.key);
      }
      XLSX.writeFile(wb, "debtor.xlsx");
    },
    itemRender (current, type, originalElement) {
      if (type === "prev") {
        return "Previous";
      } else if (type === "next") {
        return "Next";
      }
      return originalElement;
    },
    changeBranch (data) {
      this.dyn_address = data;
      if (data === "0") {
        this.data_list = [];
        console.log(this.$store.state.branch_list)
        for (const e of this.$store.state.branch_list) {
          this.getAllBranch(e.dyn_address, e.branch_code);
        }
        this.filterBranch = "all";
      } else {
        this.getAll();
        this.filterBranch = "partial";
      }
    },
    onChange (pageNumber) {
      this.currentPage = pageNumber;
    },
    select (address) {
      this.modal_data.sub_district = address.district;
      this.modal_data.district = address.amphoe;
      this.modal_data.province = address.province;
      this.modal_data.post_code = address.zipcode;
    },
    editCus (data) {
      this.modal_title = "แก้ไขข้อมูลลูกหนี้";
      // eslint-disable-next-line no-undef
      $("#modal_active").modal("show");
      this.modal_data = data;
      this.modal_data.birth_date = moment(data.birth_date);
      // console.log(moment(this.last_date).format('YYYY'))
      // console.log(moment(data.birth_date).format('YYYY'))
      this.cus_age =
        moment(this.last_date).format("YYYY") -
        moment(data.birth_date).format("YYYY");
    },
    newCus () {
      this.modal_data = {
        id: 0,
        code: "",
        name: "",
        credit_day: 0,
        debt_limit: 0,
        debt_balance: 0,
        telephone: "",
        address: "",
        sub_district: "",
        district: "",
        province: "",
        post_code: "",
        gender_id: null,
        birth_date: "",
        face_book: "",
        line_id: "",
        active_status: 1
      };
      // eslint-disable-next-line no-undef
      $("#modal_active").modal("show");
    },
    close_modal () {
      // eslint-disable-next-line no-undef
      $("#modal_active").modal("hide");
      this.modal_data = {
        id: 0,
        code: "",
        name: "",
        credit_day: 0,
        debt_limit: 0,
        debt_balance: 0,
        telephone: "",
        address: "",
        sub_district: "",
        district: "",
        province: "",
        post_code: "",
        gender_id: null,
        birth_date: "",
        face_book: "",
        line_id: "",
        active_status: 1
      };
    },
    // eslint-disable-next-line camelcase
    getAllBranch (dyn_address, branch_code) {
      this.$store.state.isLoading = true;
      let body = {
        keyword: "",
        limit: 1000000,
        status: 1
      };
      console.log(dyn_address)
      apiMain.callMisApi(
        // eslint-disable-next-line camelcase
        dyn_address + "/" + "customer/v1/list/customer",
        {
          headers: {
            "Access-Token": this.branch.access_token
          }
        },
        body,
        result => {
          if (result.response === "success") {
            const data = [...this.data_list, ...result.data];
            this.data_list = data.map(e => ({
              branch_code: branch_code,
              branch_name: this.$store.state.branch_list
                // eslint-disable-next-line camelcase
                .find(e => e.dyn_address === dyn_address)
                .branch_name.split(" ")[1],
              ...e
            }));
            let DataGroup = [];
            // console.log(this.data_list)
            this.data_list.sort((a,b) => parseInt(a.branch_code) - parseInt(b.branch_code))
            this.data_list.reduce((acc, obj) => {
              const key = obj.branch_name; // Specify the column to group by here
              if (!acc[key]) {
                DataGroup.push({ branch_code: obj.branch_code, branch_name: key , customer: [] })
                acc[key] = [];
              }
              DataGroup = DataGroup.filter(e => {
                if (e.branch_name === key)
                      e.customer.push(obj)
                return e
              })
              return acc;
            }, {});
            DataGroup.sort((a,b) => parseInt(a.branch_code) - parseInt(b.branch_code));
            this.form_data = JSON.stringify(DataGroup);
          } else {
            this.alert_msg("warning", "ดึงข้อมูลลูกหนี้", result.message);
            Swal.fire({
              title: "เชื่อมต่อข้อมูลสาขาไม่ได้",
              text: "กรุณาตรวจสอบการเชื่อมต่อ",
              icon: "warning",
              showCancelButton: false,
              confirmButtonText: "ตกลง"
            }).then(result => {
              if (result.value) {
                location.reload();
              }
            });
          }
          this.$store.state.isLoading = false;
        },
        error => {
          this.$store.state.isLoading = false;
          this.alert_msg("error", "ไม่สามารถเข้าถึงข้อมูล", error.message);
          Swal.fire({
            title: "เชื่อมต่อข้อมูลสาขาไม่ได้",
            text: "กรุณาตรวจสอบการเชื่อมต่อ",
            icon: "warning",
            showCancelButton: false,
            confirmButtonText: "ตกลง"
          }).then(result => {
            if (result.value) {
              location.reload();
            }
          });
        }
      );
    },
    getAll () {
      this.$store.state.isLoading = true;
      let body = {
        keyword: "",
        limit: 1000000,
        status: 1
      };
      apiMain.callMisApi(
        this.dyn_address + "/" + "customer/v1/list/customer",
        {
          headers: {
            "Access-Token": this.branch.access_token
          }
        },
        body,
        result => {
          if (result.response === "success") {
            this.data_list = result.data.map(e => ({
              branch_name: this.$store.state.branch_list
                .find(e => e.dyn_address === this.dyn_address)
                .branch_name.split(" ")[1],
              ...e
            }));
            let DataGroup = [];
            this.data_list.sort((a,b) => parseInt(a.branch_code) - parseInt(b.branch_code))
            // console.log(this.data_list)
            this.data_list.reduce((acc, obj) => {
              const key = obj.branch_name; // Specify the column to group by here
              if (!acc[key]) {
                DataGroup.push({ branch_name: key , customer: [] })
                acc[key] = [];
              }
              DataGroup = DataGroup.filter(e => {
                if (e.branch_name === key)
                      e.customer.push(obj)
                return e
              })
              return acc;
            }, {});
            this.form_data = JSON.stringify(DataGroup);
            // this.form_data = JSON.stringify(this.data_list);
            // console.log(this.form_data);
          } else {
            this.alert_msg("warning", "ดึงข้อมูลลูกหนี้", result.message);
            Swal.fire({
              title: "เชื่อมต่อข้อมูลสาขาไม่ได้",
              text: "กรุณาตรวจสอบการเชื่อมต่อ",
              icon: "warning",
              showCancelButton: false,
              confirmButtonText: "ตกลง"
            }).then(result => {
              if (result.value) {
                location.reload();
              }
            });
          }
          this.$store.state.isLoading = false;
        },
        error => {
          this.$store.state.isLoading = false;
          this.alert_msg("error", "ไม่สามารถเข้าถึงข้อมูล", error.message);
          Swal.fire({
            title: "เชื่อมต่อข้อมูลสาขาไม่ได้",
            text: "กรุณาตรวจสอบการเชื่อมต่อ",
            icon: "warning",
            showCancelButton: false,
            confirmButtonText: "ตกลง"
          }).then(result => {
            if (result.value) {
              location.reload();
            }
          });
        }
      );
    },
    removeCus (code) {
      Swal.fire({
        title: "ลบข้อมูลลูกหนี้",
        text: "ท่านต้องการลบข้อมูลลูกหนี้รหัส " + code + " ใช่หรือไม่ ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        reverseButtons: true
      }).then(result => {
        if (result.value) {
          this.$store.state.isLoading = true;
          var body = {
            code: code,
            active_status: 0
          };
          apiMain.callMisApi(
            this.dyn_address + "/" + "customer/v1/remove/customer",
            {
              headers: {
                "Access-Token": this.branch.access_token
              }
            },
            body,
            result => {
              if (result.response === "success") {
                this.getAll();
                this.alert_msg("success", "ลบข้อมูลลูกหนี้", result.message);
              } else {
                this.alert_msg("warning", "ดึงข้อมูลลูกหนี้", result.message);
              }
              this.$store.state.isLoading = false;
            },
            error => {
              this.$store.state.isLoading = false;
              this.alert_msg("error", "ไม่สามารถเข้าถึงข้อมูล", error.message);
            }
          );
        }
      });
    },
    action_modal () {
      if (this.modal_data.id === 0) {
        this.addCus();
      } else {
        this.updateCus();
      }
    },
    addCus () {
      this.$store.state.isLoading = true;
      this.modal_data.birth_date = moment(this.modal_data.birth_date).format(
        "YYYY-MM-DD"
      );
      this.modal_data.credit_day = parseInt(this.modal_data.credit_day);
      this.modal_data.debt_limit = parseInt(this.modal_data.debt_limit);
      this.modal_data.debt_balance = parseInt(this.modal_data.debt_balance);
      this.modal_data.active_status = parseInt(this.modal_data.active_status);
      apiMain.callMisApi(
        this.dyn_address + "/" + "customer/v1/add/customer",
        {
          headers: {
            "Access-Token": this.branch.access_token
          }
        },
        this.modal_data,
        result => {
          if (result.response === "success") {
            this.getAll();
            this.alert_msg("success", "เพิ่มข้อมูลลูกหนี้", result.message);
          } else {
            this.alert_msg("warning", "เพิ่มข้อมูลลูกหนี้", result.message);
          }
          this.$store.state.isLoading = false;
          this.close_modal();
        },
        error => {
          this.$store.state.isLoading = false;
          this.alert_msg("error", "ไม่สามารถเข้าถึงข้อมูล", error.message);
        }
      );
    },
    updateCus () {
      this.$store.state.isLoading = true;
      this.modal_data.birth_date = moment(this.modal_data.birth_date).format(
        "YYYY-MM-DD"
      );
      this.modal_data.credit_day = parseInt(this.modal_data.credit_day);
      this.modal_data.debt_limit = parseInt(this.modal_data.debt_limit);
      this.modal_data.debt_balance = parseInt(this.modal_data.debt_balance);
      this.modal_data.active_status = parseInt(this.modal_data.active_status);
      apiMain.callMisApi(
        this.dyn_address + "/" + "customer/v1/update/customer",
        {
          headers: {
            "Access-Token": this.branch.access_token
          }
        },
        this.modal_data,
        result => {
          if (result.response === "success") {
            this.getAll();
            this.alert_msg("success", "บันทึกข้อมูลลูกหนี้", result.message);
          } else {
            this.alert_msg("warning", "บันทึกข้อมูลลูกหนี้", result.message);
          }
          this.$store.state.isLoading = false;
          this.close_modal();
        },
        error => {
          this.$store.state.isLoading = false;
          this.alert_msg("error", "ลบข้อมูลลูกหนี้", error.message);
        }
      );
    }
  },
  mounted () {
    this.checkUser();
    this.$store.state.isLoading = true;
    this.getBranch();
    setTimeout(() => {
      this.branch = this.$store.state.branch_list[0];
      // this.dyn_address = this.$store.state.branch_list[0].dyn_address;
      if (this.dyn_address === "0") {
        this.data_list = [];

        for (const e of this.$store.state.branch_list) {
          // console.log(e.dyn_address)
          this.getAllBranch(e.dyn_address, e.branch_code);
        }
      } else {
        this.getAll();
      }
    }, 1000);
    // eslint-disable-next-line no-undef
    $("body").on("hidden.bs.modal", ".modal", function () {
      // eslint-disable-next-line no-undef
      $(this).removeData("bs.modal");
    });
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/customer.js